export const version = 'kunde-v1.20.0-SNAPSHOT-cf0c3ac40aeebcbf9f5942baa0eb3adb4aa4f9eb';